import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import http from "../services/http";
import { toast } from "react-toastify";
import Input from "./common/input";
import Select from "./common/select";
import UserContext from "../context/userContext";
import SidebarContext from "../context/sidebarContext";

const ManageDashboards = () => {
  const [user] = useContext(UserContext);
  const [sidebar] = useContext(SidebarContext);

  const [dashboards, setDashboards] = useState([]);
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState("");
  const [format, setFormat] = useState(1);

  const formats = [
    { id: 1, description: "Desktop" },
    { id: 2, description: "Mobile" },
  ];

  useEffect(() => {
    document.title = "FTR - Manage Dashboards";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getDashboards() {
      try {
          const { data } = await http.get(`/dashboards/${user.SITE}`);
          setDashboards(data);
      }
      catch (ex) {
        toast.error("An unexpected error occured");
      }
    }
    
    getDashboards();
  }, [user]);

  async function handleArchive(dashboard) {
    const oldDashboards = [...dashboards];
    try {
      await http.delete(`/dashboard/${dashboard.ID}`);
      setDashboards(dashboards.filter((d) => d.ID !== dashboard.ID));
      toast.success("Dashboard Archived");
    } catch (ex) {
      setDashboards(oldDashboards);
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  function handleNewDashboard() {
    setShow(true);
  }

  async function handleDashboardSubmit(e) {
    e.preventDefault();
    try {
      const { data: newDashboard } = await http.post(`/dashboard`, {
        description,
        format,
      });
      setDashboards([...dashboards, newDashboard]);
      toast.success("Dashboard Added");
      setShow(false);
    } catch (ex) {
      if (ex.response && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  return (
    <div className={sidebar ? "col-10 mt-4" : "col-12 mt-4"}>
      <button className="btn btn-primary" onClick={handleNewDashboard}>
        New
      </button>
      <table className="table">
        <caption style={{ captionSide: "top", paddingBottom: 0 }}>
          {dashboards.length} Dashboards
        </caption>
        <thead>
          <tr>
            <th>Name</th>
            <th>Data Type</th>
            <th>Manage</th>
            <th>Format</th>
            <th>Site</th>
            <th>Last Updated</th>
            <th>Updated By</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {dashboards.map((dashboard) => (
            <tr key={dashboard.ID}>
              <td>
                <Link to={`/dashboards/manage/${dashboard.ID}`}>
                  {dashboard.DESCRIPTION}
                </Link>
              </td>
              <td>
                <span
                  className={
                    dashboard.DATA_TYPE === 1
                      ? "badge badge-warning"
                      : "badge badge-success"
                  }
                >
                  {dashboard.DATA}
                </span>
              </td>
              <td>
                <span
                  className={
                    dashboard.MANAGE_TYPE === 1
                      ? "badge badge-primary"
                      : "badge badge-success"
                  }
                >
                  {dashboard.MANAGE}
                </span>
              </td>
              <td>
                <span
                  className={
                    dashboard.FORMAT_TYPE === 1
                      ? "badge badge-primary"
                      : "badge badge-success"
                  }
                >
                  {dashboard.FORMAT}
                </span>
              </td>
              <td>
                <span
                  className={
                    dashboard.SITE
                      ? "badge badge-primary"
                      : "badge badge-success"
                  }
                >
                  {dashboard.SITE ? "Local" : "Global"}
                </span>
              </td>
              <td>{moment(dashboard.LAST_UPDATED_DTS).fromNow()}</td>
              <td>{dashboard.LAST_UPDATED_BY}</td>
              <td>
                <button
                  className="btn btn-danger"
                  onClick={() => handleArchive(dashboard)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title>New Dashboard</Modal.Title>
        </Modal.Header>
        <form>
          <Modal.Body>
            <div className="form-row">
              <div className="col">
                <Input
                  name="description"
                  label="Title"
                  placeholder="Dashboard"
                  value={description}
                  onChange={({ currentTarget: input }) =>
                    setDescription(input.value)
                  }
                />
              </div>
            </div>
            <div className="form-row">
              <div className="col">
                <Select
                  name="format"
                  label="Format"
                  placeholder="Select Format..."
                  value={format}
                  options={formats}
                  onChange={({ currentTarget: input }) =>
                    setFormat(input.value)
                  }
                  listKey={"id"}
                  listName={"description"}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-primary" onClick={handleDashboardSubmit}>
              Create
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default ManageDashboards;
